module.exports = __webpack_public_path__ + "static/sport/slide5.f1ac0c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/slide5.png
// module id = O5c6
// module chunks = 0